import PageLayer from "@Layouts/views/PageLayer";
import CustomerEngagementTrailLayer from "@DataPages/components/CustomerEngagementTrail/CustomerEngagementTrailLayer";

// Icons
import CetIcon from "@/assets/icons/dataPages/customerEngagementTrail/CustomerEngagement.svg";

export default function CustomerEngagementTrail() {
	return (
		<PageLayer title="Customer Engagement Trail" icon={CetIcon}>
			<CustomerEngagementTrailLayer />
		</PageLayer>
	);
}
